import { apiClient } from './client';
import { PromptTemplate, PaginatedResponse } from '../../types';

export interface UpdatePromptTemplateRequest {
  name?: string;
  description?: string;
  template?: string;
  variables?: string[];
  expectedOutput?: string;
  isActive?: boolean;
}

export interface GetPromptTemplatesParams {
  pageIndex?: number;
  pageSize?: number;
  code?: string;
  isActive?: boolean;
}

export interface PreviewPromptTemplateRequest {
  sampleData: Record<string, any>;
}

export interface PreviewPromptTemplateResponse {
  rendered?: string;
  valid: boolean;
  error?: string;
}

export const promptTemplatesApi = {
  getPromptTemplates: async (params?: GetPromptTemplatesParams): Promise<PaginatedResponse<PromptTemplate>> => {
    return apiClient.get<PaginatedResponse<PromptTemplate>>('/api/v1/admin/prompt-templates', { params });
  },

  getPromptTemplateById: async (id: string): Promise<{ data: PromptTemplate }> => {
    return apiClient.get<{ data: PromptTemplate }>(`/api/v1/admin/prompt-templates/${id}`);
  },

  getPromptTemplateByCode: async (code: string): Promise<{ data: PromptTemplate }> => {
    return apiClient.get<{ data: PromptTemplate }>(`/api/v1/admin/prompt-templates/by-code/${code}`);
  },

  updatePromptTemplate: async (id: string, data: UpdatePromptTemplateRequest): Promise<{ data: PromptTemplate }> => {
    return apiClient.put<{ data: PromptTemplate }>(`/api/v1/admin/prompt-templates/${id}`, data);
  },

  previewTemplate: async (id: string, sampleData: Record<string, any>): Promise<{ data: PreviewPromptTemplateResponse }> => {
    return apiClient.post<{ data: PreviewPromptTemplateResponse }>(`/api/v1/admin/prompt-templates/${id}/preview`, {
      sampleData
    });
  }
};
